import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState, useEffect } from "react";
function Article14() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });

  const { ref: thirdContainer, inView: thirdInView } = useInView({
    threshold: 0
  });

  const { ref: fourContainer, inView: fourInView } = useInView({
    threshold: 0
  });

  const { ref: fiveContainer, inView: fiveInView } = useInView({
    threshold: 0
  });

  const { ref: sixContainer, inView: sixInView } = useInView({
    threshold: 0
  });

  const { ref: sevenContainer, inView: sevenInView } = useInView({
    threshold: 0
  });


  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';

      return "";
    }

    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';

      return "";
    }
    else if (thirdInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = 'active';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';

      return "";
    }
    else if (fourInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = 'active';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';

      return "";
    }
    else if (fiveInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = 'active';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';

      return "";
    }
    else if (sixInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = 'active';
      var img3 = document.getElementById("img7");
      img3.className = '';

      return "";
    }
    else if (sevenInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = 'active';

      return "";
    }
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article15');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article13');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap article14-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article14-left-img1.jpg")} />
          <img id="img2" className={getAnimationClass()} src={require("../../Images/article14-left-img2.jpg")} />
          <img id="img3" className={getAnimationClass()} src={require("../../Images/article14-left-img3.jpg")} />
          <img id="img4" className={getAnimationClass()} src={require("../../Images/article14-left-img4.jpg")} />
          <img id="img5" className={getAnimationClass()} src={require("../../Images/article14-left-img5.jpg")} />
          <img id="img6" className={getAnimationClass()} src={require("../../Images/article14-left-img6.jpg")} />
          <img id="img7" className={getAnimationClass()} src={require("../../Images/article14-left-img7.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">
          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article14-left-img1.jpg")} alt="" />
          </motion.div>
          <motion.div
            variants={textAnimate}
            className="hamburger-menu">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
            <div className="" ref={firstContainer}>
              <h1 className="fs-xl f-lora mb-1 text-brown">PERTHSHIRE </h1>
              <h2 className="f-lora-i mb-4 mb-sm-5 text-brown">Discovering the nooks & crannies. </h2>
              <p className="f-lora-i lh-base mb-4 mb-sm-5 text-brown" variants={textAnimate}>Perthshire’s location on the Highland Boundary Fault makes it a land of genuine scenic drama, drawing those in the know to its craggy peaks, ancient woodlands and dark lochs. Adrenaline thrills are easy to find, whether you’re biking, hiking, rafting or even bungee jumping, but this is also a region stuffed with art, culture, food and history – big-name attractions such as Scone Palace, Blair Castle and the Fortingall Yew are just the start.</p>
              <img className="img-fluid mb-4"
                src={require("../../Images/article14-right-img1.jpg")}
              />
              <img className="img-fluid mb-4"
                src={require("../../Images/article14-right-img2.jpg")}
              />
              <img className="img-fluid mb-4"
                src={require("../../Images/article14-right-img3.jpg")}
              />
              <img className="img-fluid mb-0"
                src={require("../../Images/article14-right-img4.jpg")}
              />
              <div className="article14-bg text-brown p-3 p-sm-5">
                <h2 className="f-lora mb-3">History</h2>
                <p className="mb-2" variants={textAnimate}>By the time the Romans reached what is now Perthshire in the 1st century AD – kicking off a relatively brief period of occupation – the region had already witnessed all manner of prehistoric settlements. When the Romans withdrew, the area became a Pictish realm, before being attacked by Vikings and then later, in the 9th century, absorbed into the kingdom of the Scots. If this all reads like a who’s-who of various historical powerbrokers, then the theme continues through the Middle Ages. Macbeth was defeated in a battle at Dunsinane Hill by Siward, Earl of Northumbria in 1054, which led to the ascension of Malcolm III to the throne, and the end of local Celtic rule. The royal burgh of Perth became the nominal Scottish capital from the early 12th century until the middle of the 15th, becoming rich through its craftspeople and traders, and witnessing periods of English rule. The town subsequently saw various religious conflicts, the coronation of Charles II, and three periods of being occupied by Jacobite supporters, before the arrival of industry in the late 18th century heralded a more settled period for both Perth and the surrounding region.</p>
              </div>
              <div className="row mb-4 mb-sm-5 align-items-center">
                <div className="col-sm-6">
                  <div className="article14-bg text-brown p-3 p-sm-5">
                    <p className="mt-3" variants={textAnimate}>They call it the Big County for a reason. Straddling both the Lowlands and the Highlands, Perthshire covers a vast central swathe of the Scottish map, its borders stretching from Rannoch Moor in the west to River Isla in the east, and from the Pass of Drumochter in the north to the fringes of the Trossachs in the south. If you’re looking for scenic diversity, in other words, you’re in the right place. Sir Walter Scott described it as “the fairest spot in the northern kingdom”, and he knew a decent view when he saw one. </p>
                    <p className="" variants={textAnimate}>But it has much more than good looks to shout about. Home to the elegant city of Perth itself – once the seat of the Scottish parliament, and with magnificent Scone Palace on its outskirts – the region also has enjoyable towns such as Aberfeldy, Pitlochry and Crieff within its borders. The little county of Kinross, meanwhile, on the banks of lovely Loch Leven, is also bundled up into the area’s overall offering, and in the rolling expanse of the Perthshire outdoors you’ll find everything from millennia-old trees and soaring Munros to canyoning adventures and luxury country hotels. </p>
                    <p className="mb-3" variants={textAnimate}>Perhaps more than anything, Perthshire puts to bed the notion that you need to venture deep into the Highlands for a true blast of epic Scottish scenery. This is a region that serves up everything from royal history to red stags, against a backdrop that’s as ruggedly handsome as they come. </p>
                  </div>
                </div>
                <div className="col-sm-6 px-3 px-sm-5">
                  <h2 className="f-lora mb-0 mt-3 text-brown">Getting <br/>there</h2>
                  <img className="img-fluid mb-4 mb-sm-5" width={"220px"}
                    src={require("../../Images/article14-right-img5.png")}
                  />
                  <p className="fs-sm text-body mb-4" variants={textAnimate}>TRAVEL // <br/>To give an idea on travel time by road,<br/>see distances below to the city of Perth: </p>
                  <div className="row mb-1 fs-sm">
                    <div className="col-6">
                      ABERDEEN
                    </div>
                    <div className="col-6">
                      1 hr, 45 mins
                    </div>
                  </div>
                  <div className="row mb-1 fs-sm">
                    <div className="col-6">
                    DUNDEE
                    </div>
                    <div className="col-6">
                    0 hrs, 35 mins
                    </div>
                  </div>
                  <div className="row mb-1 fs-sm">
                    <div className="col-6">
                    EDINBURGH
                    </div>
                    <div className="col-6">
                    1 hr, 05 mins
                    </div>
                  </div>
                  <div className="row mb-1 fs-sm">
                    <div className="col-6">
                    GLASGOW
                    </div>
                    <div className="col-6">
                    1 hr, 10 mins
                    </div>
                  </div>
                  <div className="row mb-1 fs-sm">
                    <div className="col-6">
                    INVERNESS
                    </div>
                    <div className="col-6">
                    2 hrs, 15 mins
                    </div>
                  </div>
                  <div className="row mb-1 fs-sm">
                    <div className="col-6">
                    STIRLING
                    </div>
                    <div className="col-6">
                    0 hrs, 45 mins
                    </div>
                  </div>
                   
                </div>
              </div>
            </div>

            <div className="" ref={secondContainer}>
              <img className="img-fluid mb-4 mb-sm-5"
                src={require("../../Images/article14-right-img6.jpg")}
              />
              <img className="img-fluid mb-4 mb-sm-5"
                src={require("../../Images/article14-right-img7.jpg")}
              />
              <h2 className="f-lora mb-3 text-brown">See & Do</h2>
              <p className="mb-4 mb-sm-5 text-brown" variants={textAnimate}>Whether you’re journeying through the Lowlands or the Highlands, you’ll find Perthshire packs in plenty of memorable diversions. Some have centuries-old stories under their belts, while others showcase the county’s contemporary creative spirit. The only problem – and it’s a pleasant one to have – is working out where to prioritise.</p>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">The Hermitage</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Dunkeld</h5>
                  <p className="text-body mb-4 mb-sm-5">Follow in the footprints of Queen Victoria, William Wordsworth and composer Felix Mendelssohn by stepping into this sylvan world of Douglas firs and chuckling rivers, a spread of forest created as the pleasure-ground by the 3rd Duke of Atholl – who allegedly used a cannon to scatter seeds into harder-to-reach areas. Don’t miss the Black Linn waterfall, or the manmade curiosity that is Ossian’s Hall of Mirrors.</p>

                  <h4 className="mb-1 text-brown">Meikleour Beech Hedge</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Blairgowrie</h5>
                  <p className="text-body mb-4 mb-sm-5">The word ‘hedge’ barely does justice to this gargantuan green wall, which stretches for more than half a kilometre and looms up to a height of 30 metres, granting it a spot in the Guinness Book of Records as the highest hedge on the planet. Dating back to 1745, the hedge now gets cut once a decade: a six-week task requiring a team of four. </p>

                  <h4 className="mb-1 text-brown">Faskally Woods</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Pitlochry</h5>
                  <p className="text-body">Perthshire has no shortage of forested areas, but this little swathe of mixed woodland is as enchanting as they come. Designed by the owners of Faskally House in the 19th century, it later evolved into a training ground for junior foresters. Today it’s best enjoyed on the walking trails that thread through the trees – come in autumn for the full colour spectacle. </p>
                </div>
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">Black Spout Waterfall</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Pitlochry</h5>
                  <p className="text-body mb-4 mb-sm-5">Few things compare to the sight of a 60-metre cascade tumbling through Scottish woodland. Black Spout – which is the name given to both the wood and the waterfall – can be visited on a simple, tranquil hiking trail on the outskirts of Pitlochry, and has the added benefit of being close to a couple of distilleries. Walk first, whisky later. </p>

                  <h4 className="mb-1 text-brown">Queen’s View</h4>
                  <h5 className="mb-4 fw-normal text-brown">Loch Tummel</h5>
                  <p className="text-body mb-4 mb-sm-5">Arguably the most famous panorama in Perthshire is this soul-lifting vista over Loch Tummel, gazing out across the water to the mountain of Schiehallion. Commonly thought to be named in honour of Queen Victoria, the story goes that its title is actually in tribute to the first wife of Robert the Bruce. </p>

                  <h4 className="mb-1 text-brown">Phone Box Library</h4>
                  <h5 className="mb-4 fw-normal text-brown">Bendochy</h5>
                  <p className="text-body">When BT decided to put defunct phone boxes back to public use, the residents of sedate Bendochy, near Blairgowrie, came up with a plan. Purchasing the cubicle for £1, they set about turning it into one of Scotland’s tiniest libraries. A quirky stop-off if you’re stuck for reading material. </p>
                </div>
              </div>
              
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">Scone Palace</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Perth</h5>
                  <p className="text-body mb-4 mb-sm-5">Macbeth, Robert the Bruce and Charles II were all crowned at this historic five-star attraction across the River Tay from Perth. Pronounced ‘Scoon’ – but you knew that – the remarkable ivy-clad palace has been rebuilt since it was originally constructed, yet still speaks of a hugely momentous past. See where the famous Stone of Scone once stood, tour the opulent interior, and enjoy the 100 acres of gardens (kids will love the ‘tartan’ maze). </p>

                  <h4 className="mb-1 text-brown">Drummond Castle Gardens</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Crieff</h5>
                  <p className="text-body mb-4 mb-sm-5">There are formal gardens, then there are the Drummond Castle Gardens. Considered one of the finest of their kind in Europe, they date back to the 1600s but found further fame after being redesigned and terraced in the 19th century. A vast beech-lined avenue and an Italianate parterre are among the highlights. The castle itself is a spectacle too, although it’s not open to the public. </p>

                  <h4 className="mb-1 text-brown">Blair Castle</h4>
                  <h5 className="mb-4 fw-normal text-brown">Blair Atholl</h5>
                  <p className="text-body mb-4 mb-sm-5">A whitewashed colossus on a wide, forested estate on the edge of the village of Blair Atholl, this sumptuous castle is one of Perthshire’s – if not Scotland’s – must-sees. Its baronial interior, adapted over the course some 750 years, conjures a stirring vision of how the other half lived in centuries gone by. Mary Queen of Scots and Bonnie Prince Charlie both came calling. </p>

                  <h4 className="mb-1 text-brown">Blair Atholl Watermill</h4>
                  <h5 className="mb-4 fw-normal text-brown">Blair Atholl</h5>
                  <p className="text-body">This handsome attraction is the country’s oldest watermill, still fully functioning, and stone-grinding oatmeal and flour in the traditional manner for the on-site tearooms. It dates back to the late 16th century, though it fell out of use in the 1920s before restoration began in the 1970s. </p>
                </div>
                <div className="col-sm-6">
                  <img className="img-fluid mb-4 mb-sm-5"
                    src={require("../../Images/article14-right-img8.jpg")}
                  />

                  <h4 className="mb-1 text-brown">Birks of Aberfeldy</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Aberfeldy</h5>
                  <p className="text-body mb-4 mb-sm-5">“Now Simmer blinks on flowery braes,/ And o’er the chrystal streamlets plays;/ Come let us spend the lightsome days/ In the birks of Aberfeldy.” So wrote Robert Burns, in his poem of the same name, and the birks (or birch trees) can still be visited on a winding circular walk through mature woodland. </p>

                  <h4 className="mb-1 text-brown">Fortingall Yew Tree</h4>
                  <h5 className="mb-4 fw-normal text-brown">Fortingall</h5>
                  <p className="text-body">Thought to be between 2,000 and 5,000 years old – making it one of the oldest organisms in Europe – the Fortingall Yew stands in a village churchyard and can be admired in all its gnarled, wizened, venerable glory. Legend has it that Pontius Pilate, whose father, so the tale goes, was part of a Roman mission to these parts, was born under its branches. </p>
                </div>
              </div>

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <img className="img-fluid mb-0"
                    src={require("../../Images/article14-right-img9.jpg")}
                  />
                </div>
                <div className="col-sm-6">
                  <div className="article14-bg p-4 text-brown h-100">
                    <h2 className="f-lora mb-1">The father of modern hypnosis?</h2>
                    <div className="short-divder"></div>
                    <p className="mb-0">Nineteenth-century ‘gentleman scientist’ James Braid is regarded by many as the father of modern hypnotherapy, a weighty accolade for a man who grew up in Kinross as the youngest of seven children. A trained physician with a deeply curious mind, in 1841 he became interested in the work of a travelling Swiss ‘mesmerist’ and set about trying to induce a trancelike state in his own patients. When he succeeded, finding it a valuable way of aiding certain treatments, he concluded that it was in fact a form of sleep, then coining the term ‘hypnosis’ after Hypnos, the Greek god of sleep. </p>
                  </div>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">Tomnadashan Mine</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Aberfeldy</h5>
                  <p className="text-body mb-4 mb-sm-5">This abandoned mine near Loch Tay has a quite brilliant claim to fame, appearing on screen in Monty Python & The Holy Grail as the Cave of Caerbannog, the lair of a bloodthirsty monster that, as it turns out, looks awfully like a cute bunny rabbit. </p>

                  <h4 className="mb-1 text-brown">Pitlochry Festival Theatre</h4>
                  <h5 className="mb-4 fw-normal text-brown">Pitlochry</h5>
                  <p className="text-body">From its beginnings in a tent in 1951, this unique rural theatre has evolved into a ground-breaking arts venue on the banks of the River Tummel. Expect workshops, musicals and quality stage productions. </p>
                </div>
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">Dewar’s Aberfeldy Distillery</h4>
                  <h5 className="mb-4 fw-normal text-brown">Aberfeldy</h5>
                  <p className="text-body mb-4 mb-sm-5">It was back in 1898 that the Dewar family established the distillery that would go on to produce what is today the best-selling Scotch in America. Today, a tour of its stills and warehouses gives a full sensory encounter – including, naturally, a tasting – with the single malt it’s famous for.  </p>

                  <h4 className="mb-4 text-brown">The Amulree Road</h4>
                  <p className="text-body">At more than 17km in length, the Amulree Road that coils and twists through the rolling wilderness of Glen Quaich is one of the most unforgettable drives in the country. It’s also one of the highest and, on a more sober note, one of the most dangerous. Expect a road trip worthy of the name, although the steepness of some sections makes it best avoided in winter. </p>
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-sm-6">
                  

                  <h4 className="mb-4 text-brown">Little Glenshee</h4>
                  <p className="text-body mb-4 mb-sm-5">It might be less than 20km from Perth, but Little Glenshee – and the sweeping countryside around it – feel a world away from the thrum of the city. Head here for walks and birdlife, and expect a peaceful slice of the Perthshire outdoors, with little more than farmland, hills and a mellow burn threading across the land. </p>

                  <h4 className="mb-1 text-brown">Deil’s Cauldron</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Crieff</h5>
                  <p className="text-body mb-4 mb-sm-5">After a blast of fresh air and some soothing scenery? Make a circular walk through this atmospheric wooded basin by starting in the little village of Comrie, near Crieff. The River Lednock flows through the gorge, and there’s an optional detour to the hilltop obelisk of the Melville Monument. </p>

                  <h4 className="mb-1 text-brown">Soldier’s Leap</h4>
                  <h5 className="mb-4 fw-normal text-brown">Killiecrankie, near Pitlochry</h5>
                  <p className="text-body">The Battle of Killiecrankie in 1689 has gone down as one of the bloodiest in Scottish history, although today’s majestic wooded gorge is more silent than violent. Look out for the spot where a soldier being pursued by the Jacobites hurled himself more than five metres across the River Garry. If your luck’s in, red squirrels and pine martens can also be seen. </p>

                  
                </div>
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">RSPB Loch Leven</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Kinross</h5>
                  <p className="text-body mb-4 mb-sm-5">Loch Leven is perhaps best known as the site of Loch Leven Castle, the prison island where Mary Queen of Scots was held captive, then later escaped, although a visit today is just as much about enjoying the surroundings. The Loch Leven Nature Reserve covers wetland, woodland and loch, and plays home to birdlife ranging from lapwings to little ringed plovers. </p>

                  <h4 className="mb-1 text-brown">Gleneagles</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Auchterarder</h5>
                  <p className="text-body mb-4 mb-sm-5">Few high-end hotels in the UK have quite the same cachet as Gleneagles. Garlanded in Michelin stars, ringed by championship golf courses and filled with five-star rooms and suites, this fabled countryside estate first eased open its doors in 1924. The description it was given at the time – a ‘Riviera in the Highlands’ – still rings true.  </p>

                  <h4 className="mb-1 text-brown">Black Watch Museum</h4>
                  <h5 className="mb-4 fw-normal text-brown">Perth</h5>
                  <p className="text-body">The city’s 17th-century Balhousie Castle these days plays host to the absorbing Black Watch Museum, a multi award-winning attraction dedicated to Scotland’s oldest Highland regiment. Displays lead you through from the battalion’s formation in 1739, and the perils of the World Wars, to more recent conflicts in the Middle East.  </p>
                </div>
              </div>

            </div>

            <div className="" ref={thirdContainer}>
              <img className="img-fluid mb-0"
                src={require("../../Images/article14-right-img10.jpg")}
              />
              <div className="article14-bg p-3 p-sm-5 text-brown mb-4 mb-sm-5">
                <h2 className="f-lora mb-1">The Earthquake House</h2>
                <div className="short-divder"></div>
                <p className="mb-0">Comrie might seem a quiet charmer of a village, with its riverside location and whitewashed church, but there’s more to it than meets the eye. Often known as ‘Shaky Toun’, it sits bang on the Highland Boundary Fault, meaning it experiences more tremors and earthquakes than any other settlement in the UK. It also explains the presence of the so-called Earthquake House, a tiny building constructed way back in the 1870s to house what was the world’s first modern seismometer. Today it’s one of the smallest listed buildings in Europe, and you’re welcome to visit and peek through the windows.  </p>
              </div>
              
            </div>

            <div className="" ref={fourContainer}>
              <img className="img-fluid mb-4"
                src={require("../../Images/article14-right-img11.jpg")}
              />

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <img className="img-fluid"
                    src={require("../../Images/article14-right-img12.jpg")}
                  />
                </div>
                <div className="col-sm-6">
                  <img className="img-fluid"
                    src={require("../../Images/article14-right-img13.jpg")}
                  />
                </div>
              </div>
              <h2 className="f-lora mb-4 mb-sm-5 text-brown">Towns</h2>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  

                  <h4 className="mb-4 text-brown">Aberfeldy</h4>
                  <p className="text-body mb-4 mb-sm-5">With its iconic distillery, Highland scenery and forest-ringed castle – not to mention the presence of nearby Loch Tay – peaceful Aberfeldy makes a fine base for exploring the surrounding countryside, whether you’re in search of angling, adrenaline, or just old-world charm. </p>

                  <h4 className="mb-4 text-brown">Kenmore</h4>
                  <p className="text-body mb-4 mb-sm-5">Sitting a few miles west of Aberfeldy on the shores of Loch Tay, the little village of Kenmore gives numerous reasons to call in, including the excellent, open-air Scottish Crannog Centre, which centres on a reconstructed crannog, a kind of stilted loch dwelling. </p>

                  <h4 className="mb-4 text-brown">Crieff</h4>
                  <p className="text-body mb-4 mb-sm-5">Traditions run deep in Crieff, a lively market town brimming with family-run businesses and seriously good dining options. The Glenturret Distillery (home to a Michelinstarred restaurant) and the Caithness Glass visitor centre are among the top draws, and special mention also goes to Gordon & Durward, a sweet shop in place since 1925. </p>

                  <h4 className="mb-4 text-brown">Dunkeld and Birnam</h4>
                  <p className="text-body">Separated by the River Tay, the twin towns of Dunkeld and Birnam have character, history and – yes – plenty of surrounding scenery. Make a beeline for Dunkeld Cathedral, a sacred site dating back to at least 1260, and the Birnam Oak, said to be the sole survivor of Birnam Wood, which features in Shakespeare’s Macbeth. </p>
                  
                </div>
                <div className="col-sm-6">
                  <h4 className="mb-4 text-brown">Perth</h4>
                  <p className="text-body mb-4 mb-sm-5">When Perth was formally made a city in 2012 – becoming Scotland’s seventh – it was due recognition for somewhere that, had fortune played out differently, might now be the national capital. It’s amply stocked with galleries, independent shops and historical attractions – and if that’s not enticement enough, it’s also previously been named Scotland’s Food Town of the Year. </p>

                  <h4 className="mb-4 text-brown">Pitlochry</h4>
                  <p className="text-body mb-4 mb-sm-5">The River Tummel is the lifeblood of the town of Pitlochry, a popular stopoff for those travelling north to the Highlands. Among its attractions, the Pitlochry Dam Visitor Centre is far more interesting than it sounds, and has a fish ladder to allow salmon to migrate upstream.   </p>

                  <h4 className="mb-4 text-brown">Blairgowrie</h4>
                  <p className="text-body mb-4 mb-sm-5">Once a flax-spinning centre, and now renowned for its salmon fishing and soft fruits, Blairgowrie – “Blair” to the locals – is a market town on the banks of the River Ericht, half an hour north of Perth. It makes up a twin burgh with Rattray, on the opposite side of the river. </p>

                  <h4 className="mb-4 text-brown">Alyth</h4>
                  <p className="text-body mb-4 mb-sm-5">Not far from Blairgowrie, Alyth is a village with roots stretching back to the 11th century, resulting in plenty of historic charm, from a 500-year-old packhorse bridge to the remains of an even older church. </p>

                  <h4 className="mb-4 text-brown">Blair Atholl</h4>
                  <p className="text-body">Built in the early 19th century at the confluence of the rivers Garry and Tilt, Blair Atholl is a picturesque little village best known as the location of Blair Castle, seat of the Atholl family for more than seven centuries. Take time too to visit the nearby Falls of Bruar, and the Atholl Country Life Museum.  </p>
                </div>
              </div>
            </div>

            <div className="mt-2" ref={fiveContainer}>
              <img className="img-fluid mb-4 mb-sm-5"
                src={require("../../Images/article14-right-img14.jpg")}
              />

              <h2 className="f-lora mb-4 mb-sm-5 text-brown">Family & Activities</h2>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">For Art Sake</h4>
                  <h5 className="mb-4 fw-normal text-brown">Scone</h5>
                  <p className="text-body mb-4 mb-sm-5">Unleash your inner (or actual) child at this pottery-painting workshop in Scone, which handles both group bookings and individual visits. You’ll select your item, decorate it to your choosing, then have it glazed and fired when you’re done.   </p>

                  <h4 className="mb-1 text-brown">Dewars Centre</h4>
                  <h5 className="mb-4 fw-normal text-brown">Perth</h5>
                  <p className="text-body mb-4 mb-sm-5">Self-described as the home of Scottish curling, the Dewars Centre is as fine a place as any to have a go at this unique and growing sport. There are regular ‘Try Curling’ sessions, as well as facilities for ice-skating and bowling. </p>

                  <h4 className="mb-1 text-brown">Splash White Water Rafting</h4>
                  <h5 className="mb-4 fw-normal text-brown">Aberfeldy</h5>
                  <p className="text-body mb-4 mb-sm-5">It’s all very well watching a Perthshire river flow by, but another thing entirely to be cascading down its rapids in a raft. This Aberfeldy outfit offers rafting on the Tay, the Tummel and the Orchy – with varying degrees of intensity – as well as canyoning, river bugging and standup paddleboarding.   </p>

                  <h4 className="mb-1 text-brown">Highland Safaris</h4>
                  <h5 className="mb-4 fw-normal text-brown">Aberfeldy</h5>
                  <p className="text-body">This highly thought-of attraction may be home to a red deer centre, bike trails and a kids play area, but it’s most notable for its safaris, which set off into the wilds in search of deer, grouse, mountain hares and even golden eagles. Loch Tay safaris are also on offer, offering a cruise on one of Scotland’s deepest lochs.  </p>
                </div>
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">Nae Limits Adventure Activities</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Pitlochry</h5>
                  <p className="text-body mb-4 mb-sm-5">There’s something about Perthshire that calls for getting wet and /or muddy. Nae Limits step up to the mark with a variety of high-octane activities, from rafting, quad biking and canyoning to paintball, bungee jumping and gorge-scrambling. </p>

                  <h4 className="mb-1 text-brown">Beatrix Potter Garden</h4>
                  <h5 className="mb-4 fw-normal text-brown">Birnam</h5>
                  <p className="text-body mb-4 mb-sm-5">The fabled creator of Peter Rabbit and Mrs Tiggy-Winkle spent many of her childhood summers here in Scotland, and this attraction is a charming one for kids, who can seek out statues of their favourite characters, explore a Victorian schoolroom, and much more. It forms part of the excellent Birnam Arts venue. </p>

                  <h4 className="mb-1 text-brown">Mains of Taymouth Riding Stables</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Kenmore</h5>
                  <p className="text-body mb-4 mb-sm-5">Located a brief trot from Loch Tay in beautiful Highland scenery, this trekking and riding centre welcomes riders aged four and above. Hopping into the saddle and setting off down serene forest tracks is a glorious way of experiencing the Perthshire countryside. </p>

                  <h4 className="mb-1 text-brown">Blair Atholl Bike Hire</h4>
                  <h5 className="mb-4 fw-normal text-brown">Blair Atholl</h5>
                  <p className="text-body mb-0">Offering easy access to a network of more than 50 miles of rural bike trails – including some of the UK’s best natural mountain bike tracks – this Blair Atholl hire outlet provides fullday rentals to allow you to cut loose in the great outdoors. Segways are also on offer </p>
                </div>
              </div>

              <img className="img-fluid mb-0"
                src={require("../../Images/article14-right-img15.jpg")}
              />
              <div className="article14-bg p-3 p-sm-5 text-brown mb-4 mb-sm-5">
                <h2 className="f-lora mb-1">The First Jacobite Rising</h2>
                <div className="short-divder"></div>
                <p className="mb-0">The picturesque Pass of Killiecrankie in Perthshire may seem tranquil, but it was once the stage for one of Scotland’s most intense battles. On July 27, 1689, the Jacobite forces led by Viscount Dundee clashed with government troops commanded by General Hugh Mackay. Known for the devastating Highland Charge, the Jacobites routed Mackay’s troops in a remarkably short time. However, the victory was bittersweet: Viscount Dundee, also known as “Bonnie Dundee,” was mortally wounded and died shortly after. While his death weakened the first Jacobite uprising, it didn’t end it entirely. Today, the battlefield is part of the Killiecrankie Visitor Centre, where the history and lore of the event—including tales of a soldier’s leap over the River Garry and rumoured ghostly encounters— are vividly brought to life. The Battle of Killiecrankie remains a significant chapter in Scotland’s turbulent history.  </p>
              </div>


            </div>

            <div className="" ref={sixContainer}>
              <h2 className="f-lora mb-4 mb-sm-5 text-brown">Arts & Culture</h2>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">City Contemporary Art</h4>
                  <h5 className="mb-4 fw-normal text-brown">Perth</h5>
                  <p className="text-body mb-4 mb-sm-5">A fine art gallery close to the banks of the Tay in central Perth, showcasing works by a range of top-drawer contemporary British artists, some of them already widely acclaimed, others on their way to prominence. If you know your art, this place is the real deal. </p>

                  <h4 className="mb-1 text-brown">The Fergusson Gallery</h4>
                  <h5 className="mb-4 fw-normal text-brown">Perth</h5>
                  <p className="text-body">Despite spending much of his life in France, Edinburgh-born artist and sculptor JD Fergusson was a major name in the British art scene of the early 20th century, being closely linked to the Scottish Colourist group. This gallery holds a huge collection of his influential works. </p>
                </div>
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">The Birks Cinema</h4>
                  <h5 className="mb-4 fw-normal text-brown">Aberfeldy</h5>
                  <p className="text-body mb-4 mb-sm-5">First opened in 1939, just weeks before World War II cranked into motion, this iconic local cinema fell into disuse in the 1980s, before being fully renovated to the tune of £1.8 million, reopening its doors in 2013. Today, as a state-of-the-art independent picture house, it remains a busy cinema, screening a mix of Hollywood and arthouse movies. </p>

                  <h4 className="mb-1 text-brown">Innerpeffray Library</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Crieff</h5>
                  <p className="text-body">Book-lovers, step this way. As the oldest lending library in the whole of Scotland, this wonderfully hushed venue exudes a rare sense of history, dating back as it does to 1680. Guided tours are available, and you’re still able to browse some of the rare titles in the collection. </p>
                </div>
              </div>
              
              <h2 className="f-lora mb-3 text-brown">Eat, Drink & Shop</h2>
              <p className="mb-4 mb-sm-5 text-brown" variants={textAnimate}>Perthshire does its food and drink like it does its scenery – with plenty of variety and in large amounts. Whether you’re in search of a sit-down meal, good grub on the go, or just a brilliant boutique to browse, you’ll find plenty of temptation. </p>

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">Glenlyon Tearoom</h4>
                  <h5 className="mb-4 fw-normal text-brown">Bridge of Balgie</h5>
                  <p className="text-body mb-4 mb-sm-5">It might be tucked down a singletrack road, but this traditional tearoom has some serious selling points – not least a front-row view of a highland glen. Homemade cakes and hot drinks draw in passing motorists, and you’ll also find scones, soups, sausage rolls and more. It’s about 20 miles west of Aberfeldy. </p>

                  <h4 className="mb-1 text-brown">Clootie McToot Dumplings</h4>
                  <h5 className="mb-4 fw-normal text-brown">Abernethy</h5>
                  <p className="text-body mb-4 mb-sm-5">The most pleasingly named business in Perthshire specialises in the sugary, spicy fruit pudding known as a Clootie dumpling – the first recipe for which dates back to 1747. Choose the traditional dumpling or opt for one of the alternative flavours, which range from plum and gin to cherry, date and (for an extra local kick) Lindores Abbey Aqua Vitae. </p>

                  <h4 className="mb-1 text-brown">Blair Atholl Watermill Bakery & Tearoom</h4>
                  <h5 className="mb-4 fw-normal text-brown">Blair Atholl</h5>
                  <p className="text-body">Not many bakeries have the benefit of an original watermill to grind their flour, a fact that adds even more appeal to the breads, bagels and cakes on offer at the on-site tearoom. Come for breakfast, lunch or just a cuppa and a sweet treat - the carrot cake is particularly renowned. </p>
                </div>
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">The Scottish Deli</h4>
                  <h5 className="mb-4 fw-normal text-brown">Dunkeld</h5>
                  <p className="text-body mb-4 mb-sm-5">An overflowing Scottish hamper in the form of a deli-cum-restaurant, this Dunkeld gem stocks everything from smoked meats, chutneys, haggis and cheeses to biscuits, chocolates, whisky and craft beer. If that’s not enticement enough, it also serves a tapas menu in the evenings.  </p>

                  <h4 className="mb-1 text-brown">Hettie’s Tearoom</h4>
                  <h5 className="mb-4 fw-normal text-brown">Pitlochry</h5>
                  <p className="text-body mb-4 mb-sm-5">Scooping various awards since it opened it 2010, this cracking little tearoom serves its own loose-leaf teas alongside homemade soups, sandwiches, scones, traybakes, cheesecakes and more. Look out too for the original artworks that decorate the walls, by ‘Daughter of the Stag’ Bev Nicol. </p>

                  <h4 className="mb-1 text-brown">Effie’s of Perth</h4>
                  <h5 className="mb-4 fw-normal text-brown">Perth</h5>
                  <p className="text-body">A haven of Victorian décor and perfectly blended teas, Effie’s is a family-run tearoom on Perth’s High Street. Produce is locally sourced – don’t miss the homemade strawberry jam – and top billing goes to the signature afternoon tea, served on antique silver cake stands with Royal Albert china crockery.  </p>
                </div>
              </div>

              <img className="img-fluid mb-4"
                src={require("../../Images/article14-right-img16.jpg")}
              />
              <img className="img-fluid mb-4"
                src={require("../../Images/article14-right-img17.jpg")}
              />
              <img className="img-fluid mb-4"
                src={require("../../Images/article14-right-img18.jpg")}
              />
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <div className="article14-bg p-4 text-brown h-100">
                    <h2 className="f-lora mb-1">Tayside’s lost village</h2>
                    <div className="short-divder"></div>
                    <p className="mb-0">For more than 800 years, the village of Pitmiddle was home to a community that lived through the ebbs and flows of Scottish history. Today, all that remains of the place are ruined crofts, overgrown trees and wild gooseberry bushes, the last resident having packed his bags one snowy day in 1938. Pitmiddle’s tale is a sad one, bound up in the steady decline of rural life over recent centuries – where once was a settlement of weavers, joiners, butchers and shoemakers, is today a deserted ghost village. To wander its crumbling remains is a stirring experience.</p>
                  </div>
                </div>
                <div className="col-sm-6">
                  <img className="img-fluid"
                    src={require("../../Images/article14-right-img19.jpg")}
                  />
                </div>
              </div>

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">The Taybank</h4>
                  <h5 className="mb-4 fw-normal text-brown">Dunkeld</h5>
                  <p className="text-body mb-4 mb-sm-5">Located, as you might have guessed, on the banks of the Tay, this muchloved Dunkeld pub is well known for its live trad music. Its Wednesday evening sessions are a particular highlight, but you’re welcome to grab a fiddle off the wall and start playing on any night of the week. If the weather’s fine, the riverside beer garden is a perfect spot for a pint. </p>

                  <h4 className="mb-1 text-brown">The Highland Chocolatier</h4>
                  <h5 className="mb-4 fw-normal text-brown">Pitlochry</h5>
                  <p className="text-body mb-4 mb-sm-5">Chocolatier Iain Burnett’s velvet truffles are the confectionery equivalent of A-list celebrities, having won more than 40 (yes, 40) awards, including two world golds at the International Chocolate Awards. They’re the star of the show at his Pitlochry chocolate shop, where you can also get your teeth into all manner of spiced pralines and dipped fruits. </p>

                  <h4 className="mb-1 text-brown">Grandtully Hotel</h4>
                  <h5 className="mb-4 fw-normal text-brown">Grandtully</h5>
                  <p className="text-body mb-4 mb-sm-5">Run by the team behind the exceptional Ballintaggart Farm, the nearby Grandtully Hotel offers one of the best high-end dining experiences in Perthshire, earning two AA rosettes. Menus are stacked with Scottish ingredients, from Peterhead monkfish to Loch Fyne oysters. </p>

                  <h4 className="mb-1 text-brown">Mhor 84</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Lochearnhead</h5>
                  <p className="text-body">Give me mhor, mhor, mhor. Partmotel, part-restaurant, part-café, Mhor 84 is named for its location on the A84 – the road to the Highlands. Fuel up on everything from breakfast porridge to sourdough pizzas in a welcoming atmosphere that makes it far more than just another pitstop. </p>
                </div>
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">ARAN Bakery</h4>
                  <h5 className="mb-4 fw-normal text-brown">Dunkeld</h5>
                  <p className="text-body mb-4 mb-sm-5">The words ‘artisan bakery’ are generally enough to get any rightthinking stomach rumbling, and Dunkeld’s ARAN doesn’t disappoint. Putting a creative twist on classic items (think spelt and sesame sourdough, buttered leek and brie toasties, and even bacon sandwiches with rhubarb ketchup), it also does a mean line in cakes, tarts and brownies. </p>

                  <h4 className="mb-1 text-brown">The Tea Garden at Comrie Croft</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Crieff</h5>
                  <p className="text-body mb-4 mb-sm-5">Comrie Croft is a 200-year-old farmstead reinvented as a kind of modern day eco-retreat, complete with camping, a farm shop and a seasonal tea garden that sources much of its produce from neighbouring Tomnah’a Market Garden. Come for cakes, pies, salads, soups and other goodies. </p>

                  <h4 className="mb-1 text-brown">Hansen’s Kitchen</h4>
                  <h5 className="mb-4 fw-normal text-brown">Comrie</h5>
                  <p className="text-body mb-4 mb-sm-5">A village deli selling a mouth-watering array of quality foods, whether you’re after ready meals, picnic provisions, baked goods or local beers and ciders – think anything from smoked cheddar scones to pickled samphire. It’s named after founder Iain Hansen, who set up shop in 2011. </p>

                  <h4 className="mb-1 text-brown">The Pickled Peacock</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Perth</h5>
                  <p className="text-body mb-4 mb-sm-5">Born in 2021 and based at the Cairn O’Mohr winery, The Pickled Peacock is run by two sisters – Linsay and Holly Duncan – who oversee a quirky café that uses local produce, holds wine tastings, and generally turns a light bite or coffee into an unfettered joy. A special shout-out to the haggis, cheese and chilli jam toastie. </p>

                  <h4 className="mb-1 text-brown">Tickled Trout Café</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Perth</h5>
                  <p className="text-body">Despite opening in the middle of a pandemic, the refurbished Tickled Trout Café has earned a reputation for offering quality homemade fare in a building with oodles of character. It’s based in an old mill at a trout farm – a water-channel actually runs right through the building – and the homemade smoked trout pâté is a signature item. </p>
                </div>
              </div>


            </div>

            <div className="mt-2" ref={sevenContainer}>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">Charlotte Flower Chocolates</h4>
                  <h5 className="mb-4 fw-normal text-brown">Acharn, near Aberfeldy</h5>
                  <p className="text-body mb-4 mb-sm-5">Humdrum chocs? Not here. Charlotte Flower has won legions of sweet-toothed admirers – and several awards – with her dedication to creating handmade chocolates. There’s an emphasis on using seasonal ingredients (think sloe blossom and wild mint in spring, or plum and damson in autumn), and the shop stocks thins, bars and shards, as well as Charlotte’s much-prized sea salt caramel. </p>

                  <h4 className="mb-1 text-brown">Provender Brown</h4>
                  <h5 className="mb-4 fw-normal text-brown">Perth</h5>
                  <p className="text-body">Is it a cheese counter? Is it an off-licence? Is it a bakery? Is it a gift shop? You’ll find all of the above at this brilliant Perth deli, which stocks some 2,000 items at its George Street premises (including around 100 cheeses). Its fresh bread comes courtesy of Comrie’s Wild Hearth Bakery, while its gin selection makes it one of the largest stockists in Scotland. </p>

                </div>
                <div className="col-sm-6">
                  <h4 className="mb-1 text-brown">Loch Leven’s Larder</h4>
                  <h5 className="mb-4 fw-normal text-brown">Near Kinross</h5>
                  <p className="text-body mb-4 mb-sm-5">Not many things can top the prospect of homemade shortbread, but homemade shortbread with a loch view is one of them. Loch Leven’s Larder sits a scone’s throw from the water and has no less than three different cafés alongside its deli and gift shop. The items on sale in the food hall read like a who’s who of quality local producers. </p>

                  <h4 className="mb-1 text-brown">Taste Perthshire</h4>
                  <h5 className="mb-4 fw-normal text-brown">Bankfoot, near Perth</h5>
                  <p className="text-body mb-4 mb-sm-5">Easily reachable from Perth, just off the A9, this largescale shop, food hall and deli offers exactly what its name suggests: top local produce, from seafood to filled pies. A restaurant and takeaway serves sandwiches, soups and the like, while the shop sells hampers, homewares and more.</p>

                  <h4 className="mb-1 text-brown">Gloagburn Farm Shop</h4>
                  <h5 className="mb-4 fw-normal text-brown">Tibbermore, near Perth</h5>
                  <p className="text-body">Expect quality farm shop staples at this long-standing outlet near Perth – there’s even an on-site butchery – as well as homewares, clothing and children’s accessories. The coffee shop is open daily, serving up quality breakfasts, light lunches and afternoon teas. </p>

                </div>
              </div>

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-7 py-1 py-md-5">
                  <div className="pe-4">
                    <h4 className="mb-1 text-brown">Highland Soap Company</h4>
                    <h5 className="mb-4 fw-normal text-brown">Pitlochry</h5>
                    <p className="text-body mb-4 mb-sm-5">There’s nothing quite like the smell of a soap shop, and in the case of the excellent Highland Soap Company – which handmakes its products using local ingredients such as lavender and wild raspberry – your nose is in for a treat. Shampoos, body washes and bubble baths are all on sale at this Pitlochry branch, as well as traditional soap bars. </p>

                    <h4 className="mb-1 text-brown">Tayberry Gallery</h4>
                    <h5 className="mb-4 fw-normal text-brown">Perth</h5>
                    <p className="text-body mb-4 mb-sm-5">Co-owned by creative designers Louise Forbes and Sarah Spalding, this sparkling little Perth shop is packed with unique products from British artists and makers, from prints and woodcrafts to jewellery, ceramics and accessories. Good luck leaving empty-handed. </p>

                    <h4 className="mb-1 text-brown">House of Bruar</h4>
                    <h5 className="mb-4 fw-normal text-brown">Blair Atholl</h5>
                    <p className="text-body">If country fashion’s your thing – or you’re just taken with the idea of having traditional tweed in your wardrobe – steer a course for this large store in Blair Atholl. The ladieswear and menswear collections are both huge, with plenty of cashmere and sporting outfits, and there’s also a food hall and art gallery. </p>
                  </div>
                </div>
                <div className="col-sm-5 article14-img-1">
                  
                </div>
              </div>

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6 article14-img-2">
                  
                </div>
                <div className="col-sm-6 article14-bg p-5 text-brown text-center">
                  <h2 className="f-lora mb-1 mt-5">Events</h2>
                  <div className="short-divder vDivder"></div>
                  <h4 className="mb-4 mt-5 text-brown">Solas Festival</h4>
                  <p className="text-body mb-4 mb-sm-5">Held in Errol Park, not far from Perth, this annual midsummer gathering combines art, music, debate, multinational performers and all-ages entertainment. There’s a welcoming, inclusive, optimistic feel to the event.  </p>

                  <h4 className="mb-4 text-brown">Scottish Game Fair</h4>
                  <p className="text-body mb-4 mb-sm-5">“Celebrating Conservation and the Countryside” runs the tagline for this popular country fair, which champions traditional pursuits like archery and falconry, Scottish produce, and more, at Scone Palace. </p>

                  <h4 className="mb-4 text-brown">The Enchanted Forest</h4>
                  <p className="text-body">A large-scale sound and light show held in Faskally Wood near Pitlochry, this multi-award-winning venture brings timeless magic and creativity to the dark of the forest. </p>
                  
                </div>
              </div>
              
            </div>

          </div>

        </div>
      </motion.div>

      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>

    </motion.div>

  );
}

export default Article14;
